var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListuser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_294_13536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.125 5.25C13.125 4.73292 13.0232 4.2209 12.8253 3.74318C12.6274 3.26546 12.3374 2.8314 11.9717 2.46577C11.6061 2.10014 11.172 1.8101 10.6943 1.61222C10.2166 1.41435 9.70458 1.3125 9.1875 1.3125C8.67042 1.3125 8.1584 1.41435 7.68068 1.61222C7.20296 1.8101 6.7689 2.10014 6.40327 2.46577C6.03764 2.8314 5.7476 3.26546 5.54972 3.74318C5.35185 4.2209 5.25 4.73292 5.25 5.25C5.25 5.76708 5.35185 6.2791 5.54972 6.75682C5.7476 7.23454 6.03764 7.6686 6.40327 8.03423C6.7689 8.39986 7.20296 8.6899 7.68068 8.88778C8.1584 9.08565 8.67042 9.1875 9.1875 9.1875C9.70458 9.1875 10.2166 9.08565 10.6943 8.88778C11.172 8.6899 11.6061 8.39986 11.9717 8.03423C12.3374 7.6686 12.6274 7.23454 12.8253 6.75682C13.0232 6.2791 13.125 5.76708 13.125 5.25ZM3.9375 5.25C3.9375 3.85761 4.49062 2.52226 5.47519 1.53769C6.45975 0.553123 7.79511 0 9.1875 0C10.5799 0 11.9152 0.553123 12.8998 1.53769C13.8844 2.52226 14.4375 3.85761 14.4375 5.25C14.4375 6.64239 13.8844 7.97775 12.8998 8.96231C11.9152 9.94688 10.5799 10.5 9.1875 10.5C7.79511 10.5 6.45975 9.94688 5.47519 8.96231C4.49062 7.97775 3.9375 6.64239 3.9375 5.25ZM1.3125 19.6875H17.0625C17.0133 16.4186 14.3473 13.7812 11.0619 13.7812H7.31309C4.03184 13.7812 1.36582 16.4186 1.3125 19.6875ZM0 19.7818C0 15.7418 3.27305 12.4688 7.31309 12.4688H11.0619C15.102 12.4688 18.375 15.7418 18.375 19.7818C18.375 20.4545 17.8295 21 17.1568 21H1.21816C0.545508 21 0 20.4545 0 19.7818Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_294_13536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.375,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListuser);
export default __webpack_public_path__ + "static/media/listuser.c0a3e3f39defd50a209ec5958710c371.svg";
export { ForwardRef as ReactComponent };